<template>
    <div id="contenedor-agregar-contrato-fecha">
      <v-form
        v-model="formularioValido"
        ref="registrarContratoFecha">
        <v-card>
          <v-card-title>
            Agregar fecha
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col>
                <custom-select
                  v-model="fecha.tipo"
                  :items="listadoTipos"
                  item-text="name"
                  item-value="id"
                  label="Tipo"
                  :rules="[mixReglas.requerido]">
                </custom-select>
              </v-col>
              <date-picker
                v-model="fecha.fecha"
                label="Fecha"
                :rules="[mixReglas.requerido]">
              </date-picker>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <custom-button
              @click="cerrar"
              tipo="formCancelar"
              label="Cancelar"
              class="mr-3">
            </custom-button>
            <custom-button
              @click="mixRegistrarContratoFecha"
              :disabled="!formularioValido || enviandoFormulario"
              :loading="enviandoFormulario"
              tipo="formAceptar"
              label="Guardar">
            </custom-button>
          </v-card-actions>
        </v-card>
      </v-form>
    </div>
</template>

<script>
import DatePicker from '@/components/inputs/DatePicker.vue';
import CustomSelect from '@/components/inputs/sinColumnas/Select.vue';
import CustomButton from '@/components/buttons/Button.vue';
import mixContratoFechas from './mixContratoFechas';

export default {
  mixins: [mixContratoFechas],
  components: {
    CustomSelect,
    CustomButton,
    DatePicker,
  },
  props: {
    idContrato: {
      type: String,
      required: true,
    },
    tiposAgregados: {
      type: Array,
    },
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      fecha: {
        idContrato: this.idContrato,
        tipo: '',
        fecha: '',
      },
    };
  },
  methods: {
    limpiarFormulario() {
      this.$refs.registrarContratoFecha.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
  computed: {
    listadoTipos() {
      return this.tipos
        .filter(({ id }) => !this.tiposAgregados
          .filter((tipo) => tipo !== 'fecha-de-suspension-de-trabajos')
          .filter((tipo) => tipo !== 'fecha-de-reinicio-de-trabajos')
          .includes(id));
    },
  },
};
</script>

<style>

</style>
